module.exports = __webpack_public_path__ + "img/backyard-patio.1959565c.webp";